import { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { PageShell } from '@components/layout/PageShell.js'
import { ModePageHeader } from '@components/layout/ModePageHeader.js'
import { EmptyPanel } from '@components/primitives/EmptyPanel.js'
import { Card } from '@components/primitives/Card.js'
import { WIKI_ENTRIES, WIKI_CATEGORIAS } from '@content/wiki-entries.js'
import { wikiArticlePath } from '@utils/constants.js'

export function WikiPage() {
  const [cat, setCat] = useState('')
  const [q, setQ] = useState('')

  const filtered = useMemo(() => {
    let list = WIKI_ENTRIES
    if (cat) list = list.filter((e) => e.categoria === cat)
    const term = q.trim().toLowerCase()
    if (term.length >= 2) {
      list = list.filter(
        (e) =>
          e.titulo.toLowerCase().includes(term) ||
          e.resumo.toLowerCase().includes(term) ||
          e.tags.some((t) => t.includes(term)),
      )
    }
    return list
  }, [cat, q])

  return (
    <PageShell>
      <ModePageHeader
        title='Enciclopédia da construção'
        subtitle='Conceitos, terminologias, diferenças e recomendações. Consulta rápida offline.'
      />

      <div className='cf3-wiki-filters'>
        <input
          type='search'
          className='cf3-wiki-search'
          placeholder='Buscar conceito…'
          value={q}
          onChange={(e) => setQ(e.target.value)}
          aria-label='Buscar na enciclopédia'
        />
        <div className='cf3-chip-row' role='group' aria-label='Categorias'>
          <button
            type='button'
            className={`cf3-chip${!cat ? ' cf3-chip--active' : ''}`}
            onClick={() => setCat('')}
            aria-pressed={!cat}
          >
            Todos
          </button>
          {WIKI_CATEGORIAS.map((c) => (
            <button
              key={c}
              type='button'
              className={`cf3-chip${cat === c ? ' cf3-chip--active' : ''}`}
              onClick={() => setCat(c)}
              aria-pressed={cat === c}
            >
              {c}
            </button>
          ))}
        </div>
      </div>

      <div className='cf3-wiki-grid'>
        {filtered.map((entry) => (
          <Link key={entry.slug} to={wikiArticlePath(entry.slug)} className='cf3-wiki-card-link'>
            <Card surface='raised' clickable className='cf3-wiki-card'>
              <span className='cf3-wiki-card__cat'>{entry.categoria}</span>
              <h2 className='cf3-wiki-card__title'>{entry.titulo}</h2>
              <p className='cf3-wiki-card__resumo'>{entry.resumo}</p>
            </Card>
          </Link>
        ))}
      </div>

      {filtered.length === 0 && (
        <EmptyPanel
          title='Nenhum artigo encontrado'
          description='Tente outro termo ou categoria. A enciclopédia cobre conceitos, materiais e etapas da construção.'
          actionLabel='Limpar filtros'
          onAction={() => {
            setQ('')
            setCat('')
          }}
        />
      )}
    </PageShell>
  )
}
